import { Button, Col, Form, Input, Row } from 'antd';
import React, { useRef } from 'react';
import { useAudioCat } from './AudioCatState';

function Add() {
    const formRef = useRef();
    let { addCat } = useAudioCat()
    
    const handleFinish = (values) => {
        addCat(values);
        formRef.current?.resetFields();
    }
    
    return (
        <>
            <Form
                ref={formRef}
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={handleFinish}
                autoComplete="off"
            >
                <Row>
                    <Col span={20}>
                        <Form.Item
                            name="title"
                            rules={[
                                {
                                    required: true,
                                    message: "To'ldirish majburiy",
                                },
                            ]}
                        >
                            <Input placeholder="Kitob nomi" />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Saqlash
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>

            </Form>
        </>
    );
}

export default Add;